import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";

/**
 * Fila del panel de filtros: el control a la izquierda y, en una columna a la
 * derecha, el check para mostrarlo en la barra principal. La crea
 * `*appFilterItem`; el control se mantiene aqui aunque tambien se muestre en la barra.
 */
@Component({
  selector: "app-filter-pin-row",
  templateUrl: "./filter-pin-row.html",
  styleUrls: ["./filter-pin-row.scss"]
})
export class FilterPinRowComponent {
  /** Template del filtro. */
  @Input() template: TemplateRef<any> | null = null;

  /** Llave de traduccion del nombre del filtro. */
  @Input() label = "";

  /** Indica si el filtro esta en la barra principal. */
  @Input() checked = false;

  /** Se emite al cambiar el check con el nuevo estado. */
  @Output() changed = new EventEmitter<boolean>();

  /**
   * Cambia la visibilidad del filtro desde el check.
   * @param event Evento `change` del checkbox.
   * @returns void
   */
  onChange(event: Event): void {
    this.changed.emit((event.target as HTMLInputElement).checked);
  }
}
